import { useQuery } from "@apollo/client";
import AnniversaryWidget from "components/_Pages/Explore/Widgets/AnniversaryWidget";
import BannerWidget from "components/_Pages/Explore/Widgets/BannersWidget/BannersWidget";
import BirthdayWidget from "components/_Pages/Explore/Widgets/BirthdayWidget";
import BuySellWidget from "components/_Pages/Explore/Widgets/BuySellWidget";
import MagazineWidget from "components/_Pages/Explore/Widgets/MagazineWidget";
import CoinsRankingWidget from "components/_Pages/Explore/Widgets/CoinsRankingWidget";
import EndorsementWidget from "components/_Pages/Explore/Widgets/EndorsementWidget";
import RecognitionCorporateValueRankingWidget from "components/_Pages/Explore/Widgets/RecognitionCorporateValueRankingWidget";
import BenefitsWidget from "components/ui/benefitsWidget/benefitsWidget";
import ListExternalLink from "components/ui/listExternalLink/listExternalLink";
import { useVendor } from "context/vendor/vendor.provider";
import {
  GET_CORPORATE_VALUES_BY_VENDOR,
  GET_SIMPLE_VENDOR_USER_LIST,
  ICorporateValueResponse,
  IVendorUserListResponse
} from "gql/CorporateValues/queries";
import { useEffect } from "react";
import { useAllUserStore } from "stores/recognition/useAllUserStore";
import { useCorporateStore } from "stores/recognition/useCorporateStore";

interface ISidePanelProps {
  render: boolean;
  className?: string;
}

export default function SidePanel(props: ISidePanelProps) {
  const { render = true } = props;
  const { vendor } = useVendor();
  const {
    dataCorporate,
    setLoadingCorporate,
    setErrorCorporate,
    setDataCorporate
  } = useCorporateStore();

  const { dataAllUser, setDataAllUser, setLoadingAllUser, setErrorAllUser } =
    useAllUserStore();

  const { loading: loadingCorporate } = useQuery<ICorporateValueResponse>(
    GET_CORPORATE_VALUES_BY_VENDOR,
    {
      fetchPolicy: "cache-first", // Use cache when available
      skip: !render || !vendor || Boolean(dataCorporate), // Skip if vendor is not loaded yet or data is already cached
      onCompleted: (data) => {
        setDataCorporate(data);
      },
      onError: (error) => {
        setErrorCorporate(error);
      }
    }
  );

  useEffect(() => {
    setLoadingCorporate(loadingCorporate);
  }, [loadingCorporate, setLoadingCorporate]);

  const { loading: loadingUser } = useQuery<IVendorUserListResponse>(
    GET_SIMPLE_VENDOR_USER_LIST,
    {
      fetchPolicy: "cache-first", // Use cache when available
      skip: !render || !vendor || Boolean(dataAllUser), // Skip if vendor is not loaded yet or data is already cached
      onCompleted: (data) => {
        setDataAllUser(data);
      },
      onError: (error) => {
        setErrorAllUser(error);
      }
    }
  );

  useEffect(() => {
    setLoadingAllUser(loadingUser);
  }, [loadingUser, setLoadingAllUser]);

  if (!render) {
    return null;
  }
  return (
    <div className="flex min-w-0 flex-col">
      <div
        className={`mt-6 flex min-w-0 flex-col gap-3 ${props.className}`}
      >
        {vendor?.enableBirthdayAndAnniversary && (
          <>
            <BirthdayWidget variant="v2" />
            <AnniversaryWidget variant="v2" />
            <EndorsementWidget variant="v2" />
          </>
        )}

        {vendor?.enableCorporateValue && (
          <RecognitionCorporateValueRankingWidget variant="v2" />
        )}

        {vendor?.enableBuySell && <BuySellWidget variant="v2" />}

        {vendor?.enableMagazine && <MagazineWidget variant="v2" />}

        {vendor?.enableCoins && (
          <>
            <CoinsRankingWidget variant="v2" />
          </>
        )}

        {<BannerWidget clean variant={"info"} />}
        <ListExternalLink variant="v2" />
        {vendor?.enableBenefits && <BenefitsWidget variant="v2" />}
        {vendor?.enableCoins && <BannerWidget variant={"events"} />}
      </div>
    </div>
  );
}
